export default {
  name: 'project_currency',
  component_path: 'modules/procedures/blocks/project/BlockProjectCurrency',
  static_options: {
    has_conditions: true
  },
  conditions: [
    {
      model:'client.is_multi_currency',
      comparison_operator:'eq',
      logic_operator:'and',
      value_type:'checked'
    }
  ]
}